import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { Track, ProgramCategory } from '../../../enums'

/**
 * DTO for Program list item response
 */
export class ProgramListItem {
  @ApiProperty({
    description: 'Program UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  id: string

  @ApiProperty({
    description: 'Unique program code',
    example: 'MATH-6EME-CORE',
  })
  code: string

  @ApiProperty({
    description: 'Program title',
    example: 'Mathématiques 6ème',
    type: 'string',
  })
  title: string

  @ApiPropertyOptional({
    description: 'Program summary',
    example: 'Programme de mathématiques pour la classe de 6ème',
  })
  summary?: string

  @ApiProperty({
    description: 'Subject UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  subjectId: string

  @ApiProperty({
    description: 'Level UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  levelId: string

  @ApiProperty({
    description: 'Track',
    enum: Track,
    example: 'COLLEGE',
  })
  track: Track

  @ApiProperty({
    description: 'Program category',
    enum: ProgramCategory,
    example: 'CORE',
  })
  category: ProgramCategory

  @ApiPropertyOptional({
    description: 'Related subject',
    type: 'object',
    additionalProperties: true,
  })
  subject?: {
    id: string
    code: string
    label: string
  }

  @ApiPropertyOptional({
    description: 'Related level',
    type: 'object',
    additionalProperties: true,
  })
  level?: {
    id: string
    code: string
    label: string
  }

  @ApiPropertyOptional({
    description: 'Counts of related entities',
    type: 'object',
    additionalProperties: true,
  })
  _count?: {
    versions: number
  }

  @ApiProperty({
    description: 'Creation timestamp',
  })
  createdAt: Date

  @ApiProperty({
    description: 'Last update timestamp',
  })
  updatedAt: Date
}

/**
 * DTO for Program lookup (minimal info for dropdowns)
 */
export class ProgramLookupDto {
  @ApiProperty({
    description: 'Program UUID',
    example: '123e4567-e89b-12d3-a456-426614174000',
  })
  id: string

  @ApiProperty({
    description: 'Unique program code',
    example: 'MATH-6EME-CORE',
  })
  code: string

  @ApiProperty({
    description: 'Program title',
    example: 'Mathématiques 6ème',
    type: 'string',
  })
  title: string
}
